import axios from 'axios';

export const apiInstance = axios.create({
    //baseURL: 'https://us-central1-green-mountain-synergy.cloudfunctions.net/api'
    baseURL:'https://us-central1-joshuaforvermont.cloudfunctions.net/api'
})